import { useCallback, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';

const DEFAULT_DEBOUNCE_TIME = 200;

export const useDebounce = (
  fnToDebounce: (...args: any) => void,
  durationInMs = DEFAULT_DEBOUNCE_TIME,
) => {
  const debouncedFn = useRef(debounce(fnToDebounce, durationInMs)).current;
  const execute = useCallback((...args: any) => debouncedFn(...args), [debouncedFn]);
  useEffect(
    () => () => {
      debouncedFn.cancel();
    },
    [debouncedFn],
  );
  return execute;
};
